import { Avatar, Checkbox, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

import { deepOrange } from "@mui/material/colors";
import React from "react";
import StyledBadge from "../helpers/StyledBadge";

const EmployeeTile = (props) => {
    const { selected, employee, handleToggle, disabled } = props;
    return (
        <ListItem
            secondaryAction={
                <Checkbox
                    edge="start"
                    checked={selected}
                    tabIndex={-1}
                    // disabled={disabled}
                    onChange={() => handleToggle(employee)}
                    disableRipple
                    // inputProps={{ 'aria-labelledby': labelId }}
                    sx={{
                        color: '#526680',
                        '&.Mui-checked': {
                            color: '#526680'
                        },
                    }}
                />}
            disablePadding>
            <ListItemButton
                className="cursor-pointer"
                role={undefined}
                // disabled={disabled}
                onClick={() => handleToggle(employee)}
                dense>
                <ListItemIcon>
                    <StyledBadge
                        overlap="circular"
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
                        <Avatar
                            sx={{ bgcolor: deepOrange[500] }}
                            alt="Remy Sharp"
                        />
                    </StyledBadge>
                </ListItemIcon>
                <ListItemText primary={employee?.names} secondary={employee?.email} />
            </ListItemButton>
        </ListItem>);
}


export default EmployeeTile;